export default "__VITE_ASSET__DfFHPn6f__"